import { Box, Flex, Stack, Text } from '@mantine/core'

import CoinIcon from '@/components/CoinIcon'
import { useI18nRouter } from '@/i18n/navigation'

import type { StockItem } from './hooks'
import styles from './index.module.css'

interface StockRowProps {
  stock: StockItem
}

export default function StockRow({ stock }: StockRowProps) {
  const router = useI18nRouter()

  const onClickRow = () => {
    router.push(`/price/stocks/${stock.symbol.toUpperCase()}`)
  }

  return (
    <Flex className={styles.stockRow} onClick={onClickRow}>
      <Box w={32} h={32} bdrs={888} bg={'var(--content-primary)'}>
        <CoinIcon
          size={32}
          coin={{
            icon: stock.logo,
            name: stock.name,
            symbol: stock.symbol,
            slug: stock.slug,
          }}
        />
      </Box>
      <Stack gap={2} ml={8} flex={1}>
        <Text variant={'body'} lineClamp={1}>
          {stock.name}
        </Text>
        <Text variant={'subtitle'} c={'var(--content-secondary)'}>
          {stock.symbol}
        </Text>
      </Stack>
    </Flex>
  )
}
